import type { SavedAddress } from 'mobx/Localization/types'

export enum EventKey {
	AddressSaved = 'addressSaved',
	AddressFailedToSave = 'addressFailedToSave',
	OrderTypeFlowsUnavailable = 'orderTypeFlowsUnavailable'
}

export interface BaseEvent<K extends EventKey, D> {
	key: K
	data?: D
}

export type AddressSavedEvent = BaseEvent<EventKey.AddressSaved, { savedAddress: SavedAddress }>
export type AddressFailedToSaveEvent = BaseEvent<EventKey.AddressFailedToSave, { error: unknown }>
export type OrderTypeFlowsUnavailableEvent = BaseEvent<EventKey.OrderTypeFlowsUnavailable, undefined>

export type Event = AddressSavedEvent | AddressFailedToSaveEvent | OrderTypeFlowsUnavailableEvent

export interface Handler {
	name: string
	key: Event['key']
	func: (data: Event['data']) => void | Promise<void>
}
